const routes = [
  {
    path: "/events",
    component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/eventsPage/EventsPage"),
    children: [
      {
        path: "events-list",
        name: "eventsList",
        component: () => import(/* webpackChunkName: "EventsIndex" */ "./views/eventsPage/EventsPage")
      },
      {
        path: "*",
        redirect: { name: "eventsList" }
      }
    ]
  },
  {
    path: "/event-page",
    name: "EventPage",
    component: () => import(/* webpackChunkName: "EventEntityPage" */ "./views/eventPage/EventPage")
  },
  {
    path: "/event-waitlist-upsell-dialog",
    name: "eventWaitlistUpsellDialog",
    component: () => import("./components/list/eventWaitlistUpsellDialog/eventWaitlistUpsellDialog")
  },
];
export default routes;

